export default __webpack_public_path__ + "static/client1-a03f99a4956c88b16a8d19471d4cab10.jpg";